
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Contact() {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Navigate to the home page and scroll to the contact section
    navigate('/#contact', { replace: true });
  }, [navigate]);
  
  // This is just a loading state while redirecting
  return (
    <div className="flex items-center justify-center min-h-screen">
      <p className="text-lg text-gray-600">Redirecting to contact form...</p>
    </div>
  );
}
